import PageRouteConfiguration from '@deltek/specification-client/core/Configurations/PageRouteConfiguration'
import React from 'react'
import { Routes } from 'routes'

/**
 * This component contains top-level route configurations.
 * Nested routes will be defined within their respective parent components.
 */
const MainPageRouting: React.FC<{ userRoles: string[] }> = ({ userRoles }) => {
    return <PageRouteConfiguration routes={Routes} userRoles={userRoles} />
}

export default MainPageRouting
